export enum RatingSize {
  M = 'm',
  L = 'l',
}

export enum RatingReviewsPosition {
  Left = 'left',
  Right = 'right',
}

export interface RatingData {
  rating: number;
  reviewsCount?: number;
}
